export default {
    abonplata: "Абоненттік төлем",
    absent: "Жоқ",
    access_restriction: "Кіруді шектеу",
    accountant_fio: "Бас бухгалтердің ТАӘ",
    accrue_bonuses_on_bonus_payments: "Бонустармен төлеуге бонустарды есептеу",
    acquiring_fee: "% эквайринга",
    activate_bonus_system: "Бонустық жүйені мұрағаттау",
    add_field: "Бағытты қосу",
    add_user: "Пайдаланушыны қосу",
    additional_doctors: "Қосымша дәрігерлер",
    additional_green_api: "Қосымша Green API",
    additional_green_api_max: "Қосымша Green API Max",
    additional_green_api_telegram: "Қосымша Green API Telegram",
    additional_jet_api: "Қосымша JET API",
    additional_modules: "Қосымша модульдер",
    additional_partner_api: "Қосымша api серіктестігі",
    additional_space: "Қосымша орын",
    admins_limit: "Әкімшілердің лимиті",
    Advance: "Депозит",
    advance_calculated: "Депозит",
    advance_payment: "Бір реттік төлем",
    after_discounts: "Жеңілдіктерді есепке алғаннан кейін",
    after_technic_deduction: "Техникті есептегеннен кейін",
    after_visit: "Келгеннен кейін еске салу",
    after_visit_day_passed: "Келгеннен кейін (бірден)",
    AgreementDocument: "Келісім шаблоны",
    akt_text: "көрсетілген қызметтер актісінде белгі",
    all_administrators: "Барлық әкімшілер",
    all_rights: "Барлық құқықтар",
    all_visits: "Барлық жазбалар",
    allow: "Рұқсат ету",
    allow_negative_deposits: " Депозиттерді шегерімге есептен шығаруға рұқсат ету",
    allow_opening_several_visits_at_the_same_time: "Бірнеше келуді бір уақытта ашуға рұқсат ету",
    allowed_ips: "Тіркелгіге кіруге болатын IP мекенжайлар",
    api: "API",
    api_token: "API токен",
    are_you_sure_you_want_to_delete_branch: " Филиалды жойғыңыз келе ме?",
    are_you_sure_you_want_to_delete_company: " Компанияны жойғыңыз келе ме?",
    are_you_sure_you_want_to_delete_notification: " Хабарламаны жойғыңыз келе ме?",
    are_you_sure_you_want_to_delete_source: "Дерек көзін жойғыңыз келе ме?",
    are_you_sure_you_want_to_delete_tag: " Белгіні жойғыңыз келе ме?",
    ask_for_more: "Тағы сұрау",
    ask_reason_cancel: " Келуді болдырмау себебін сұрау ",
    ask_reason_not_come: " «Келмеді» статусы кезінде себебін сұрау",
    ask_reason_reschedule: "Келуді ауыстыру себебін сұрау",
    assistants_connected: "Ассистенттер модулін қосу",
    automatic_conflict_task_creation: " Кесте қайшылығында тапсырмаларды автоматты түрде жасау ",
    available_disk_space: " Дискідегі қол жетімді орын, МБ (0 - лимитсіз)",
    before_discounts: "Жеңілдіктерді есепке алғанға дейін",
    before_technic_deduction: "Техникті есептегенге дейін",
    before_visit: "Келу алдындағы еске салу",
    before_visit_day_in_advance: "келу туралы бір күн бұрын еске салу (бірден)",
    billing: "Биллинг",
    billing_payment: "Төлем",
    billing_turned_off: "Төлем өшірілді",
    bonus: "Бонус",
    bonus_accrued: "Бонустар есептелді",
    bonus_adjustment: "Бонустарды түзету",
    bonus_payment: "Бонуспен төлеу",
    bonus_percent_can_be_used: "Бонустармен төлеуге болатын сатудың ең жоғары үлесі",
    bonus_percent_of_cheque: "Сатудан бонустардың пайызы",
    bonus_system: "Бонустық жүйе",
    bonuses: "Бонустар",
    bonuses_payment: "Бонустармен төлеу",
    branch_address: "Филиалдың мекенжайы",
    branch_contacts: "Филиалдың байланыс деректері",
    branch_inn: "Филиалдың ЖСН",
    branches: "Филиалдар",
    branches_connected: "Филиалдың ақылы модулін қосу",
    by_chairs: "Креслолар бойынша",
    calendar_text_color: "Күнтізбедегі мәтін түсі",
    calendar_view_by_default: "Әдепкі бойынша күнтізбе түрі",
    cancel_and_move_reason: "Бас тарту және ауыстыру себебі",
    cancel_and_move_reasons: "Бас тарту және ауыстыру себептері",
    change_tariff: "Тарифті ауыстыру",
    cities: "Қалалар",
    city: "Қала",
    client_tag: "Белгі",
    ClientDocument: "Пациенттің құжаты",
    ClientNote: "Ескертпе",
    ClientTag: "Пациент тегі",
    clinic: "Клиника",
    clinic_data: "Клиниканың деректері",
    clinic_inn: "Клиниканың ЖСН",
    clinic_is_blocked: "Клиника бұғатталған",
    clinic_name: "Клиника атауы",
    clinic_name_in_cheque: "Чектегі клиника атауы",
    ClinicAdditional: "Клиниканың қосымша баптаулары",
    clinics: "Клиникалар",
    ClinicTariff: "Клиника тарифі",
    close: "Жабу",
    cloud_space: "Бұлттағы орын",
    communications: "Коммуникациялар",
    company_data: "Компания деректері",
    ComplexService: "Кешенді қызмет",
    configuration: "Конфигурация",
    connected_successfully: "Сәтті қосылды",
    connection_failed: "Қате байланыс",
    control_system: "Бақылау жүйесі",
    countries: "Елдер",
    country: "Ел",
    crm_application_created: "CRM өтінім жасалды",
    crm_connected: "CRM ақылы модулін қосу",
    Curator: "Куратор",
    currency_rates: "Валюта курсы",
    CustomRole: "Рөл",
    data: "Деректер",
    date_of_registration: "Тіркеу күні",
    day: "Күн",
    deduct_acquiring_from_salary: "Жалақыдан эквайринг есептеу",
    deduct_warranty_from_salary: "Қызметкерлерге кепілдік жағдайы бойынша жалақы есептемеу",
    deleted: "Жою",
    demo: "Демо",
    DepositByAccount: "Шот бойынша депозит",
    director_data: "Басшының деректері",
    director_fio: "Директордың ТАӘ",
    disk_space_limit: "Диск орнының лимиті (Мб)",
    do_not_deduct_acquiring_from_technic_absolute: "Абсолютті есептеумен техниктерден эквайрингті шегеруге болмайды",
    do_not_send_notifications_if_period_passed: " Мерзімі өтіп кетсе, келу туралы ескертуді жібермеу ",
    do_not_show: "Көрсемеңіз",
    Doctor: "Дәрігер",
    'doctor-services': "Дәрігер - қызметтер",
    DoctorAssistant: "Ассистент",
    doctors_limit: "Дәрігерлердің лимиті",
    DoctorScheduleConfiguration: "Дәрігер кестесінің баптауы",
    DogovorDocument: "Шарт шаблоны",
    DynamicConfig: "Конфигурация",
    egisz_prod: "Жауынгерлік режимде ЕГИСЗ",
    EGISZRecord: "ЕГИСЗ-ге жіберу",
    enter_ip_address: "IP-мекенжайды енгізіңіз",
    error_code: "Қате коды",
    field_configuration_in_diary: "Күнделіктегі өрістерді орнату",
    field_configuration_in_teeth_general: "Тістер қойындысында жалпы өрістерді орнату",
    field_configurations_in_description: "Сипаттамадағы өрістерді баптау",
    field_configurations_in_teeth: "Тістердегі өрістерді баптау",
    finance: "Қаржы",
    free: "Бос",
    free_day: "Тегін күн",
    general: "Жалпы",
    GeneratedDocument: "Жасалған құжат",
    has_additional_doctors: "Қосымша дәрігерлер бар",
    higher_number_higher_priority: " Нөмір неғұрлым жоғары болса, тізімдегі опция соғұрлым жоғары болады ",
    hour: "сағ",
    hours: "сағат",
    image_hidden: "Сурет жасырылған",
    in_development: "Әзірлеуде",
    insurance_company: "Сақтандыру компаниясы",
    integrations: "Біріктіру",
    interface: "Интерфейс",
    ioka: "Ioka",
    ip_note: " Бағдарламаға кіру мүмкіндігін жоғалтпау үшін IP мекенжайын енгізгенде мұқият болыңыз. Сізде клиникада статикалық IP мекенжайы болған жағдайда ғана пайдалануға болады.",
    jetapi_connected: "JET API модулін қосу",
    'kit materials sync': " Материалдарды жиынтыққа байланыстыру ",
    kpp: "КПП",
    last_login: "Соңғы кіру",
    legal_address: "Заңды мекенжайы",
    legal_name: "Заңды атауы",
    license: "Лицензия",
    license_issue_body: "лицензия кіммен берілді",
    license_issue_date: "Лицензияны беру күні",
    license_num: "Лицензия #",
    location_on_map: "Картада орналасқан жері",
    logo: "Логотип",
    logout_interval_timeout: " Белсенділік болмағанда шығу аралығы (әкімші тіркелгілері үшін)",
    logs: "Логи",
    logs_journal: "Әрекет ету журналы",
    Manager: "Әкімші",
    manager2: "Менеджер",
    manual: "Қолмен",
    max_doctor_amount: "Дәрігерлердің максималды саны",
    max_qr_instructions: "Телефондағы QR кодын Max қолданбасында оқыңыз",
    min: "минут",
    min_symbols: "Минимум таңбалар",
    minute: "минут",
    minutes: "минут",
    model_id: "Модельдің Id",
    model_type: "Модель түрі",
    month: "Ай",
    monthly_payment: "Айлық төлем",
    months_to_consider_patient_lost: " Пациент жоғалды деп есептелетін айлар саны ",
    more_than_one_day: "Бір күннен артық",
    more_than_one_visit: "Бір келуден артық",
    next_payment: "Келесі төлем",
    not_connected: "Қосылмаған",
    notification_channel: "Жеткізу түрі",
    notification_setting: "Хабарлама",
    notification_type: "Хабарлама түрі",
    notifications: "Хабарламалар",
    NotificationSetting: "Хабарлама",
    NotificationWaitingResponse: "Растау хабары күтілуде",
    occupied: "Бос емес",
    of_few_hours: "сағат",
    ogrn: "НМТН",
    oid_ministry_rf: "РФ Денсаулық сақтау министрлігінің OID",
    on: "Қосулы",
    on_pay_page: "Төлем парақташасында",
    online_booking: "Онлайн-жазба",
    online_booking_activate: "Онлайн-жазбаны іске қосу",
    online_booking_categories: "Қызметтер санатын көрсету",
    online_booking_feedbacks: "Пікірлер қызметін іске қосу",
    online_booking_map: "Филиал картасын көрсету",
    online_booking_max_days: " Күніне ең көп жазу уақыты ",
    online_booking_path: " Пациенттің онлайн жазылу жолы ",
    online_booking_time: " Күнтізбедегі уақытты брондау немесе брондамау",
    only_after_accordance_with_trustme: "Тек trustme.kz келіскеннен кейін",
    only_after_payment_received: "Тек пациенттен төлем алған кезде",
    paid_functionality: "Төленетін қызмет",
    paid_till: "дейін төленді",
    paid_with_bonus: "Бонустармен төленеді",
    partner_api_limit: "Тегін серіктестік API шегі",
    Patient: "Пациент",
    patient_conditions: "Пациенттердің жағдайы",
    patient_sources: "Пациенттердің дерек көздері",
    PatientComment: "Пациенттің пікірі",
    patients_import: "Пациенттерді импорттау",
    pay: "Төлеу",
    pay_methods: "Төлеу тәсілі",
    pay_methods_acquiring: " Эквайринг-терминалға беру үшін ақы төлеу тәсілдері ",
    pay_methods_cash: " Қолма-қол ақша ретінде көрсетілетін төлеу тәсілдері ",
    pay_system: "Төлем жүйесі",
    payable: "Ақылы",
    Payment: "Төлем",
    payment_id: "Төлем Id",
    percent_accrual_for_administrator: " Әкімшіге пайызды есептеу ",
    percent_accrual_for_personnel: "Персоналға пайызды есептеу",
    period_by_default: "Әдепкі бойынша кезең",
    permanent_patients_hint: " Пациентті тұрақты деп есептеу керек пе: а) оның мәртебесі бар кем дегенде екі келу немесе шотында қызметтері болған кезде, тіпті бір күн ішінде б) оның кем дегенде екі түрлі күні болған кезде ",
    plan_treatment_text: "Емдеу жоспарындағы белгі",
    PlanSession: "Емдеу жоспарының кезеңі",
    PlanTreatment: "Емдеу жоспары",
    popup: "Попап",
    Price: "Прайс позициясы",
    price_per_additional_doctor: "Қосымша дәрігер үшін баға",
    price_per_additional_partner_api: "Қосымша серіктестік api бағасы",
    price_per_additional_space: "Қосмыша орын үшін баға (100 Мб)",
    program_language: "Бағдарлама тілі",
    prolong: "Ұзарту",
    purchase: "Сатып алу",
    recipient: "Алушы",
    Record: "Жазба",
    record_tag: "Келулер үшін ұяшық",
    record_tags: "Келулер үшін ұяшықтар",
    record_timing_enabled: " 'Келулердің басталуы мен аяқталуы' бақылау жүйесі",
    record_types: "Жазбалар түрі",
    RecordTooth: "Тіс",
    reject: "Болдыртпау",
    required_fields_to_close_visit: "Келуді жабу үшін міндетті өріс",
    requires_payment: "Қосымша ақы қажет",
    reset_verb: "Қалпына келтіру",
    right: "Құқық",
    rights: "Құқықтар",
    salary_accrual: "Дәрігерлерге/әкімшілерге/кураторларға пайыздарды есептеу логикасы",
    salary_accrual_for_personnel: " Дәрігерлерге/әкімшілерге/кураторларға жалақы есептеу ",
    salary_accrual_for_personnel_with_assistants: "Дәрігерлердің/әкімшілердің/кураторлардың/ассистенттердің жалақысы",
    salary_accrual_for_technics: "Техниктерге жалақы есептеу",
    salary_accrual_with_assistants: "Дәрігерлер/әкімшілер/кураторлар/ассистенттер үшін пайыздарды есептеу логикасы",
    save_settings: "Параметрлерді сақтау",
    Scan: "Скан",
    send_time: "Жіберу уақыты",
    sending_after_save_or_finish: " Басқан кезде келудің нәтижесін/құжатты ЕГИСЗ жіберуді сұрату:",
    sendouts_only_in_day_time: " Жаппай тарату күндізгі уақытта жіберу (09.00 - 22.00)",
    server_error: " Жүйе сіздің сұрауыңызды орындай алмады. Әрекетті қайталаңыз немесе қолдау көрсету қызметіне хабарласыңыз ",
    services_import: "Қызметтерді импорттау",
    'services-doctor': "Қызметтер - дәрігер",
    short_title: "Қысқартылған атауы",
    show_complex_materials_for_teeth: " Жиынтықтар мен материалдарды \"Тістер\" қойынды бетінде Емдеу карточкасында көрсету",
    show_description_in_forms: " 043, 058 форматындағы келуге түсініктемені көрсету ",
    show_doctor_in_documents: "Құжаттарды басып шығару кезінде дәрігерге көрсетіңіз",
    show_images: "Суреттерді көрсету",
    show_preinstalled_templates: "Алдын ала орнатылған үлгілерді көрсету",
    show_service_classificator_data_in_documents: "Жіктеуіштен басып шығарылған құжаттарда қызметтің кодын және атауын пайдаланыңыз",
    show_teeth_general: " Емдеу карточкасындағы \"Тістер\" қойындысында жалпы өрістерді көрсету ",
    sign_type: "Қолтаңба түрі",
    sort_order: "Көрсету тәртібі",
    source: "Дерек көзі",
    sources: "Дерек көздері",
    StaffWork: "Қызметкер жұмысы",
    super_user: "Суперпайдаланушы",
    superadmin: "Суперәкімші",
    superadministrators: "Суперәкімшілер",
    supermanager: "Суперменеджер",
    SuperManager: "Әкімші",
    switched_to_version_2: "2.0 нұсқасына өтті",
    sync_data: "Деректерді синхрондау",
    table_settings: "Кесте параметрлері",
    tag: "Ұяшық",
    tag_id: "Белгі",
    tags: "Белгілер",
    tags_for_custom_notifications: " Ақпаратты автоматты түрде шығаруға арналған тегтер:",
    tags_for_notifications: " Ақпаратты автоматты түрде шығаруға арналған тегтер:",
    tariff: "Тариф",
    tariff_payment_expires_in_days: " Тариф бойынша төлем бүгін аяқталады | Тариф бойынша төлем {day} күні аяқталады | Тариф бойынша төлем {day} күні аяқталады ",
    tariffs: "Тарифы",
    task_created: "Тапсырмаларды жасау",
    Technic: "Техник",
    technic_salary_accrual: "Техниктерге пайыздарды есептеу логикасы",
    techsupport_panel: "Техникалық қолдау панелі",
    templates: "Үлгілер",
    templates_agreements: "Келісім үлгілері",
    templates_categories: "Стандартты санаттар",
    templates_contracts: "Шарттардың үлгілері",
    templates_for_fields: "Өрістер үшін үлгілер",
    templates_text: "Мәтіндік үлгілер",
    templates_treatments: "Емдеу үлгілері",
    test: "Тест",
    this_may_take_several_minutes_do_not_close_the_window: " Бұл бірнеше минутқа созылуы мүмкін. Терезені жаппаңыз",
    time_after_visit: "визиттен кейін",
    time_before_visit: "Келуге дейін",
    time_interval_value: "Уақыт аралығының шамасы",
    time_zone: "Сағаттық белдеу",
    to_billing: "Биллингті баптауға",
    to_the_one_who_accepted_payment: "Төлемдерді қабылдаушыға",
    to_the_one_who_made_record: "жазбаны жасаушыға",
    top: "Топ",
    treatment_finished: "Емдеу аяқталды",
    turn_off: "Өшіру",
    turn_on_autosign: "Автоматты қол қоюды қосу",
    turned_off: "Өшірулі",
    turned_on: "Қосулы",
    ukrainian: "Украин",
    unblock_for_3_days: "3 күнге бұғаттан шығару",
    updated: "Өзгертілді",
    use_bonuses_on_salary: " Бонустармен төленген жалақыны есептеу ",
    use_proxy: "Проксиді пайдалану",
    User: "Пайдаланушы",
    user_id: "Пайдаланушының Id",
    UserAdditional: "Пайдаланушының қосымша деректері",
    uzbek: "Өзбек",
    verify: "Верификациялау",
    'visit services sync': "Қызметтерді байланыстыру",
    visit_cancel: "Келуден бас тарту",
    visit_comment: "Келуге түсіндірме",
    visit_created: "Келуді қалыптастыру",
    visit_result: "Келу нәтижесі",
    visit_results: "Келу нәтижесі",
    visit_type: "Қабылдау түрі",
    warehouse_connected: "Қойманың ақылы модуліне қосылу",
    WarehouseInventarizationSheet: "Түгендеу ведомосы",
    WarehouseOperation: "Қойма операциясы",
    week: "Апта",
    when_changing_tariff_all_payments_will_nullify: " Тариф өзгерген жағдайда барлық төлемдер жойылады ",
    which_branches_use_online_booking: " Қандай филиалдар онлайн жазбаны пайдаланады ",
    which_clients_to_consider_permanent: " Қандай клиенттерді тұрақты деп есептеу керек ",
    work_time_from: "бастап жұмыс уақыты",
    work_time_to: "дейін жұмыс уақыты",
    your_current_ip: "Сіздің ағымдағы IP",
    your_tariff_plan_is_not_paid: "Сіздің тарифтік жоспарыңыз төленбеген",
    zero_unlimited: "0 - шектеусіз"
}
